import { Button, Icon } from "@orgmym/leeloo-core";
import { useTranslation } from "react-i18next";

import { CREATOR_OLD_CHAT } from "@/shared/constants/routes";

import * as styles from "./chat-migration-banner.css";

// Light banner atop the new chat, offering a way back to the legacy monolith chat.
export const ChatMigrationBanner = () => {
  const { t } = useTranslation();

  const goToOldChat = () => {
    window.location.assign(CREATOR_OLD_CHAT);
  };

  return (
    <div className={styles.banner} data-testid="chat-migration-banner">
      <span className={styles.iconBadge} aria-hidden="true">
        <Icon name="message" size="medium" />
      </span>

      <div className={styles.content}>
        <span className={styles.title}>
          {t("chat_migration_banner_title", "Nouveau chat")}
        </span>
        <span className={styles.subtitle}>
          {t(
            "chat_migration_banner_subtitle",
            "Vous utilisez la nouvelle messagerie"
          )}
        </span>
      </div>

      <Button
        variant="primary"
        size="small"
        leftIcon="history"
        onClick={goToOldChat}
        className={styles.cta}
        data-testid="chat-migration-banner-old-chat"
      >
        {t("chat_migration_banner_cta", "Ancien chat")}
      </Button>
    </div>
  );
};

export default ChatMigrationBanner;
